module.exports = __webpack_public_path__ + "static/img/step4.157bfb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step4.png
// module id = aPsZ
// module chunks = 1